module.exports = __webpack_public_path__ + "static/media/17.34cba41f.JPG";